import { render, staticRenderFns } from "./EventItineraryCommentTable.vue?vue&type=template&id=12e0fc68"
import script from "./EventItineraryCommentTable.vue?vue&type=script&lang=js"
export * from "./EventItineraryCommentTable.vue?vue&type=script&lang=js"
import style0 from "./EventItineraryCommentTable.vue?vue&type=style&index=0&id=12e0fc68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports